<!-- Header -->
<div class="row space-between gap-32 w100">
    <div class="col gap-8">
        <h1>Welcome, {{ userPrename !== '' ? userPrename : 'Coach' }}</h1>
        <div class="row gap-8 align-center w100">
            @for (invitationLink of invitationLinks; track $index) {
                <div class="row w100 gap-8 align-center">
                    <div class="row gap-8">
                        <rr-btn
                            type="link"
                            size="Small"
                            (btnclick)="copyLink(invitationLink, 'link')"
                            >Copy quick invite</rr-btn
                        >
                    </div>
                    <span class="invitation-link">{{ invitationLink }}</span>
                </div>
            }
        </div>
    </div>
</div>
<!--Invitation Links -->
<!--<div class="card">
    <div class="uppercase-label tiny">Your invitation links:</div>
    <div class="invitation-container row gap-8 align-center">
        @for (invitationLink of invitationLinks; track $index) {
            <span class="invitation-link">{{ invitationLink }}</span>
            <rr-btn
                type="link"
                size="Small"
                (btnclick)="copyLink(invitationLink, 'link')"
                >Copy</rr-btn
            >
        }
    </div>
</div>-->
<!-- Card-Area -->
<div class="row gap-32">
    <!-- Licences Overview -->
    <div class="card founders">
        <div class="uppercase-label tiny">Total Active founders</div>
        <div class="row gap-8 align-center">
            <rr-icon tone="base" class="roundicon" name="users"></rr-icon>
            <h2>{{ mentorUsers.length }}</h2>
        </div>
        <div class="row gap-4 align-center">
            <rr-icon name="star" class="stroke-{{ licenseTrending }}"></rr-icon>
            <div class="color-{{ licenseTrending }} strong">
                {{ licenseData[0].freeSeats || 0 }}
            </div>
            <div>licences left</div>
        </div>
    </div>

    <!-- Total Streams Overview -->
    <div class="card totalstreams">
        <div class="uppercase-label tiny">Total Streams</div>
        <div class="row gap-8 align-center">
            <rr-icon tone="base" class="roundicon" name="wind"></rr-icon>
            <h2>{{ totalStreams }}</h2>
        </div>
        <div class="row gap-4 align-center">
            <rr-icon
                [name]="totalstreamsTrendingIcon"
                class="stroke-{{ totalstreamsTrending }}"
            ></rr-icon>
            <div class="color-{{ totalstreamsTrending }} strong">
                {{ totalstreamsTrendingPercetage.toFixed(2) }}%
            </div>
            <div>compared to last month</div>
        </div>
    </div>
</div>

<div class="listwrapper w100 col gap-24">
    <!-- User list -->
    <div class="w100 row align-center space-between">
        <h3 class="listheadline">Your invitees</h3>
        <div class="col w-100">
            <rr-input
                type="search"
                placeholder="Search invitees"
                [FormControl]="searchQuery"
            >
            </rr-input>
        </div>
    </div>
    <div
        class="w100 grow-1 align-center justify-center gap-8 col loading"
        *ngIf="loadingData === true"
    >
        <img src="/images/loading.gif" alt="Loading..." />
        <div class="uppercase-label">Loading data ...</div>
    </div>

    <div class="newuserlist col w100 gap-8">
        @for (invitee of newInvitees; track invitee.id) {
            <app-invitee
                [invitee]="invitee"
                [licenseData]="licenseData"
                (isLoading)="isLoading = $event"
                (declinedLeadId)="removeInviteeFromLocalList($event)"
                (acceptedInvite)="acceptedUserInvite($event)"
            >
            </app-invitee>
        } @empty {
            <p i18n>You currently do not have any pending invitees</p>
        }
    </div>

    @if (mentorUsers.length) {
        <div class="userlist col w100 gap-8">
            @for (activeFounder of mentorUsers; track activeFounder.id) {
                <app-active-founder
                    [activeFounder]="activeFounder"
                    (isLoading)="isLoading = $event"
                    (revokedFounder)="removeFounderFromLocalList($event)"
                >
                </app-active-founder>
            }
        </div>
    }
</div>

@if (isLoading === true) {
    <rr-spinner></rr-spinner>
}
